import React from 'react';
import Avatar from '@atlaskit/avatar';
import {
  Icon, Spinner
} from '@blueprintjs/core';
import { inject, observer } from 'mobx-react';
import { formatTime } from '../../helpers/time';

@inject('viewStore', 'jobStore') @observer
class InvoicesTable extends React.Component {
  
  componentDidMount() {
    let { job } = this.props;
    this.props.jobStore.loadJobContents(job)
  }

  render() {
    let { 
      jobStore: {
        jobInvoices,
        jobAssociations: {
          isLoading
        }
      } 
    } = this.props
    const {
      viewStore
    } = this.props;
    if (isLoading) {
      return <div className="spinner-center"><Spinner size='25' /></div>
    }
    if (jobInvoices.length === 0) {
      return (
        <div className="no-data-found">
          <img src="/noInvoice.svg" />
          <h3>No Invoices</h3>
          <p>No invoices have been created for this job yet.</p>
          <button className="add-new-item-btn" onClick={this.props.handleInvoiceClick}>Add Invoice</button>
        </div>
      )
    }
    return (
      <div>
          {
            jobInvoices.map((invoice) => {
              return (
                <div className="tabs-data-card"  key={invoice.id} onClick={() => {viewStore.ShowInvoice({ uuid: invoice.attributes.id })}}> 
                  <div className="card-style">         
                    <div width="10px" className="customer-avatar">
                      <Avatar src={encodeURI(`https://ui-avatars.com/api/?name=${invoice.attributes.created_by.full_name}&size=64`)} size='large' />
                    </div>
                    <div className="job-number" width="150px">
                      <p className="secondary">#{invoice.attributes.number}</p>
                      <p className="primary">By {invoice.attributes.created_by.full_name}</p>
                    </div>
                  </div>
                  
		              <div className="job-details-status">
                    <div className="status-alignment">
                      <span className='bp3-tag bp3-minimal bp3-intent-primary'>
                        {invoice.attributes.status}
                      </span>
                    </div>
                    <div className="job-date-time">
                      {/* <p className='time-entry primary'>{this.calculateTotal(invoice)}</p> */}
                      <p className='secondary'>{ formatTime(invoice.attributes.formatted_created_at) }</p>
                    </div>
		              </div>
                  {/* <div>
                    <Icon icon="caret-right" />
                  </div> */}
                </div>
              )
            })
          }
        </div>
    )
  }
}

export default InvoicesTable;